'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { CompareFAQEntry } from '@/types/compare'

interface CompareFAQProps {
  title: string
  faqs: CompareFAQEntry[]
}

function FAQItem({ question, answer }: CompareFAQEntry) {
  const [open, setOpen] = useState(false)

  return (
    <div className="border-border border-b last:border-0">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full cursor-pointer items-start justify-between gap-4 py-4 text-left"
        aria-expanded={open}
      >
        <span className="text-ink text-sm font-semibold md:text-[15px]">
          {question}
        </span>
        <ChevronDown
          size={16}
          className={cn(
            'text-hint mt-0.5 shrink-0 transition-transform duration-200',
            open && 'rotate-180'
          )}
          aria-hidden="true"
        />
      </button>
      <div
        className={cn(
          'grid transition-all duration-200',
          open ? 'grid-rows-[1fr] pb-4' : 'grid-rows-[0fr]'
        )}
      >
        <div className="overflow-hidden">
          <p className="text-body text-sm leading-relaxed">{answer}</p>
        </div>
      </div>
    </div>
  )
}

export function CompareFAQ({ title, faqs }: CompareFAQProps) {
  return (
    <section className="mx-auto max-w-2xl px-5 pt-16 md:px-6 md:pt-24">
      <h2 className="font-heading text-ink text-2xl font-semibold md:text-3xl">
        {title}
      </h2>
      <div className="theme-card mt-6 px-5 md:px-6">
        {faqs.map((faq) => (
          <FAQItem key={faq.question} {...faq} />
        ))}
      </div>
    </section>
  )
}
